module.exports = __webpack_public_path__ + "img/visuel4a-hk.a042b550.jpg";